import palette from '../palette';

const { red_toyota, clear_blue, white } = palette;

const colors = {
  Layout: {
    header_background: red_toyota,
    header_color: white,
    link_color: clear_blue,
  },
};

export default colors;
